export enum AdministrationPanels {
  MEMBERS = 'MEMBERS',
  CONTENT = 'CONTENT',
  CONTENT_ACTORS = 'CONTENT_ACTORS',
  CONTENT_PROJECTS = 'CONTENT_PROJECTS',
  CONTENT_RESOURCES = 'CONTENT_RESOURCES',
  MAPS = 'MAPS',
  MAP_ATLAS = 'MAP_ATLAS',
  MAP_QGIS_PROJECT = 'MAP_QGIS_PROJECT',
  HIGHLIGHTS = 'HIGHLIGHTS',
  COMMENTS = 'COMMENTS',
  COMMENTS_ACTORS = 'COMMENTS_ACTORS',
  COMMENTS_PROJECTS = 'COMMENTS_PROJECTS',
  COMMENTS_RESOURCES = 'COMMENTS_RESOURCES',
  COMMENTS_MAP = 'COMMENTS_MAP',
  INDICATORS = 'INDICATORS',
  PARAMETRAGE_INDICATEUR = 'PARAMETRAGE_INDICATEUR',
}
